var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.lang,attrs:{"href":_vm.path}},[_c('img',{attrs:{"id":"logo","alt":"MEDITECH FINDER LOGO","width":"306","height":"30","src":"images/img_logo.png"}})])}
var staticRenderFns = []

export { render, staticRenderFns }